/**
 *  @class
 *  @function Pagination
 */

// if (!customElements.get('pagination-theme')) {
//   class Pagination extends HTMLElement {
//     constructor() {
//       super();
//       const id = this.dataset.section;
//       this.button = this.querySelector('.load-more');
//       this.wrapper = this.closest('.pagination--wrapper');
//       this.grid = document.querySelector(`[data-id="${id}"]`);
//       this.page = 1;
//       this.page_size = this.dataset.pageSize;
//     }

//     connectedCallback() {
//       if (this.classList.contains('pagination-type--loadmore')) {
//         this.initLoadMore();
//       }
//       if (this.classList.contains('pagination-type--infinite')) {
//         this.initInfiniteScroll();
//       }
//     }

//     addUrlParam(search, key) {
//       const newParam = `${key}=${this.page}`;
//       if (!search) return `?${newParam}`;

//       const params = search.replace(new RegExp(`([?&])${key}[^&]*`), `$1${newParam}`);
//       return params === search ? `${search}&${newParam}` : params;
//     }

//     initLoadMore() {
//       this.button.addEventListener('click', () => {
//         this.loadProducts();
//         this.button.blur();
//       });
//     }

//     initInfiniteScroll() {
//       this.observer = new IntersectionObserver(entries => {
//         if (entries[0].intersectionRatio === 1) {
//           this.loadProducts();
//         }
//       }, {
//         threshold: [0, 1]
//       });
//       this.observer.observe(this);
//     }

//     async loadProducts() {
//       if (this.hasAttribute('loading')) return;

//       this.page++;
//       this.setAttribute('loading', 'true');
//       const url = `${document.location.pathname}${this.addUrlParam(document.location.search, 'page')}`;

//       try {
//         const response = await fetch(url);
//         const responseText = await response.text();
//         this.renderProducts(responseText, url);
//         this.renderCounts(responseText);

//         dispatchCustomEvent('pagination:page-changed', { url });
//       } catch (error) {
//         console.error('Error loading products:', error);
//       } finally {
//         this.removeAttribute('loading');
//       }
//     }

//     renderProducts(html, url) {
//       const gridToReplace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
//       if (!gridToReplace) {
//         if (this.observer) this.observer.unobserve(this);
//         this.hide();
//         return;
//       }

//       const products = gridToReplace.querySelectorAll('.columns');
//       console.log("products", products)
//       products.forEach((product) => {
//         this.grid.appendChild(product);
//         product.querySelectorAll('.lazyload').forEach((image) => {
//           lazySizes.loader.unveil(image);
//         });
//       });
//         // <-- Apply layout update here -->
//   this.updateProductCardsLayout(this.grid);
//       if (products.length < this.page_size) {
//         this.hide();
//       }

//     }
//     renderCounts(html) {
//       const newCounts = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');

//       if (!newCounts) {
//         return;
//       }
//       this.wrapper.querySelector('#ProductCount').innerHTML = newCounts.innerHTML;
//     }

//     hide() {
//       if (this.button) {
//         this.button.style.display = 'none';
//       }
//       // Hide the entire pagination-theme component
//       this.style.display = 'none';
//     }

//     updateProductCardsLayout(grid) {
//   const layout = localStorage.getItem('productLayout') || 'grid'; // 'grid' or 'list'
  
//   grid.querySelectorAll('product-card').forEach(card => {
//     const image = card.querySelector('figure.product-card-image');

//     // Skip if already processed
//     if (card.querySelector('.product-list-flex-wrapper')) return;

//     if (layout === 'list') {
//       const flexWrapper = document.createElement('div');
//       flexWrapper.className = 'product-list-flex-wrapper';
//       flexWrapper.style.display = 'flex';
//       flexWrapper.style.flexDirection = 'row';
//       flexWrapper.style.alignItems = 'center';
//       flexWrapper.style.justifyContent = 'space-between';

//       const infoRating = card.querySelector('.product-info-rating-wrapper');
//       const bottom = card.querySelector('.product-card-info--bottom');

//       if (infoRating) flexWrapper.appendChild(infoRating);
//       if (bottom) flexWrapper.appendChild(bottom);

//       // Safely insert wrapper after figure
//       if (image && image.parentNode === card) {
//         image.insertAdjacentElement('afterend', flexWrapper);
//       } else {
//         card.appendChild(flexWrapper);
//       }
//     } else {
//       // Grid view: ensure flexWrapper is removed if switching back
//       const existingWrapper = card.querySelector('.product-list-flex-wrapper');
//       if (existingWrapper) {
//         const parent = existingWrapper.parentNode;
//         while (existingWrapper.firstChild) {
//           parent.insertBefore(existingWrapper.firstChild, existingWrapper);
//         }
//         existingWrapper.remove();
//       }
//     }
//   });
// }

//   }

//   customElements.define('pagination-theme', Pagination);
// }


if (!customElements.get('pagination-theme')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.wrapper = this.closest('.pagination--wrapper');
      this.grid = document.querySelector(`[data-id="${id}"]`);
      this.page = 1;
      this.page_size = this.dataset.pageSize;
    }

    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) this.initLoadMore();
      if (this.classList.contains('pagination-type--infinite')) this.initInfiniteScroll();
      // Update layout on initial load
      this.updateProductCardsLayout();
    }

    addUrlParam(search, key) {
      const newParam = `${key}=${this.page}`;
      if (!search) return `?${newParam}`;
      const params = search.replace(new RegExp(`([?&])${key}[^&]*`), `$1${newParam}`);
      return params === search ? `${search}&${newParam}` : params;
    }

    initLoadMore() {
      this.button.addEventListener('click', () => {
        this.loadProducts();
        this.button.blur();
      });
    }

    initInfiniteScroll() {
      this.observer = new IntersectionObserver(entries => {
        if (entries[0].intersectionRatio === 1) this.loadProducts();
      }, { threshold: [0, 1] });
      this.observer.observe(this);
    }

    async loadProducts() {
      if (this.hasAttribute('loading')) return;

      this.page++;
      this.setAttribute('loading', 'true');
      const url = `${document.location.pathname}${this.addUrlParam(document.location.search, 'page')}`;

      try {
        const response = await fetch(url);
        const responseText = await response.text();
        this.renderProducts(responseText, url);
        this.renderCounts(responseText);
        dispatchCustomEvent('pagination:page-changed', { url });
      } catch (error) {
        console.error('Error loading products:', error);
      } finally {
        this.removeAttribute('loading');
      }
    }

    renderProducts(html, url) {
      const gridToReplace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
      if (!gridToReplace) {
        if (this.observer) this.observer.unobserve(this);
        this.hide();
        return;
      }

      const products = gridToReplace.querySelectorAll('.columns');
      products.forEach(product => {
        this.grid.appendChild(product);
        product.querySelectorAll('.lazyload').forEach(image => lazySizes.loader.unveil(image));
      });

      if (products.length < this.page_size) this.hide();
    }

    renderCounts(html) {
      const newCounts = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
      if (!newCounts) return;
      const countElem = this.wrapper.querySelector('#ProductCount');
      if (countElem) countElem.innerHTML = newCounts.innerHTML;
    }

    hide() {
      if (this.button) this.button.style.display = 'none';
      this.style.display = 'none';
    }
  }

  customElements.define('pagination-theme', Pagination);
}

